import { useQuery } from '@tanstack/react-query';
import { fetchBadges } from './badges.api';

export const badgeKeys = { all: ['badges'] as const };

/**
 * Badges are derived from work on every read, so they move whenever an
 * assignment or a review does. A short stale time keeps the dashboard honest
 * without refetching on every render.
 */
export function useBadges(enabled = true) {
  return useQuery({
    queryKey: badgeKeys.all,
    queryFn: fetchBadges,
    enabled,
    staleTime: 30_000,
  });
}
